<template>
    <div class="
      bg-gray-200 text-gray flex items-center px-8

      lg:justify-around

      uppercase font-bold
    ">
        <div
            class="
              hidden

              lg:block
            ">
            <div class="text-xs font-caption">{{ $t('BASE_PRICE') }}</div>
            <div class="text-[18px] font-bold">
                {{`${defaultUnitPrice}`}}
            </div>
        </div>

        <plus-icon class="
          size-4 hidden

          lg:block
        " />

        <div class="
          hidden

          lg:block
        ">
            <div class="text-xs font-caption">{{ $t('ADD_ONS') }}</div>
            <div class="text-[18px] font-bold">
                {{ `${customizationsPrice}` }}
            </div>
        </div>

        <equal-icon class="
          size-4 hidden

          lg:block
        " />

        <div class="text-gray-darkest">
            <div class="text-xs font-caption">
                {{ $t('SUB_TOTAL') }}
            </div>
            <div class="text-[18px] font-bold">
                {{`${defaultSubtotalPrice}`}}
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";
</style>

<script>
    import PlusIcon from './icons/PlusIcon.vue';
    import EqualIcon from './icons/EqualIcon.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        props: {
            label: String,
        },

        components: {
            PlusIcon,
            EqualIcon,
        },

        computed: {
            /**
             * Current view controller.
             */
            viewController() {
                return this.customizerStore.viewController;
            },

            zeroPrice() {
                return this.customizerStore.zeroPrice;
            },

            /**
             * Subtotal unit price.
             */
            defaultUnitPrice() {
                return this.customizerStore.defaultUnitPrice || this.zeroPrice;
            },

            /**
             * Subtotal unit price.
             */
            subtotalUnitPrice() {
                return this.customizerStore.subtotalUnitPrice || this.zeroPrice;
            },

            /**
             * Return if the default unit price does not equal the current unit price.
             * Uses string comparison for formatted values
             */
            isDiscounted() {
                return this.subtotalUnitPrice !== this.defaultUnitPrice;
            },

            currentStep() {
                return this.appStore.currentStep;
            },

            defaultSubtotalPrice() {
                return this.customizerStore.defaultSubtotalPrice || this.zeroPrice;
            },

            personalizations() {
                return this.customizerStore.personalizations;
            },

            customizationsPrice() {
                return this.customizerStore.customizationsPrice || this.zeroPrice;
            },
        },
    };
</script>
